import { useFeatureFlagEnabled } from '@posthog/react';

/** Person-level gate (PostHog user properties). */
export const PERMIT_PDF_GEN_USER_FLAG = 'permit-pdf-gen-user';
/** Org/group-level gate — evaluated against the active `organization` group (see `setPosthogOrganization`). */
export const PERMIT_PDF_GEN_ORG_FLAG = 'permit-pdf-gen-org';

/**
 * Permit PDF generation is enabled only when both PostHog flags are true.
 * Undefined/false on either flag keeps the feature off.
 */
export function usePermitPdfGenerationEnabled(): boolean {
  const userAllowed = useFeatureFlagEnabled(PERMIT_PDF_GEN_USER_FLAG);
  const orgAllowed = useFeatureFlagEnabled(PERMIT_PDF_GEN_ORG_FLAG);
  return userAllowed === true && orgAllowed === true;
}
